<ng-container *transloco="let t; read: 'home'">
  <div class="home">
    <div class="scrollContainer">
      <div
        class="scrollContainer__link"
        id="home"></div>
    </div>
    <div class="p-grid p-nogutter p-mt-0 p-jc-center section-margin">
      <div
        class="p-col-12 p-md-6 p-xl-5 home__left"
        id="home__left">
        <img
          class="bgImg p-d-none p-d-xl-block"
          src="assets/images/bg1-img.svg"
          alt="tear" width="1532" height="1026">
        <div
          class="calculator p-shadow-9"
          #calculatorRef>
          <div
            class="calculator__headers p-grid p-nogutter p-text-center p-ai-center">
            <div
              class="p-col-4 header"
              [ngClass]="
                typeOfPolicy === 'invoice' ? 'header--isActive' : 'header'
              "
              tabindex="0"
              (mouseleave)="hideOverlayPanel(opInvoice)"
              (click)="selectTypeOfPolicy('invoice')"
              (keyup.enter)="selectTypeOfPolicy('invoice')">
              <p>{{ t('tab.header1.short') }}</p>
              <div
                class="imgWrapper"
                #imgWrapperInvoice>
                <img
                  src="assets/icons/info.svg"
                  class="p-mx-2"
                  alt="info"
                  tabindex="0"
                  (mouseover)="opInvoice.show($event)"
                  (focus)="opInvoice.show($event)" width="19" height="23">
                <p-overlayPanel
                  class="index-1"
                  styleClass="index-1"
                  #opInvoice
                  [dismissable]="true"
                  [showTransitionOptions]="'200ms'"
                  [appendTo]="
                    isMobile && calculatorRef
                      ? calculatorRef
                      : imgWrapperInvoice
                  "
                  [baseZIndex]="50000">
                  <ng-template pTemplate>
                    <div (mouseleave)="opInvoice.hide()">
                      <div class="p-mb-2">
                        <div class="textGrey">
                          <span class="p-text-bold">{{
                            t('tab.header1.long')
                          }}</span>
                          <span [innerHTML]="t('tab.header1.content')"></span>
                        </div>
                      </div>
                      <a routerLink="/gap-fakturowy">{{ t('tab.showMore') }}</a>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </div>
            <div
              class="p-col-4 header"
              [ngClass]="
                typeOfPolicy === 'casco' ? 'header--isActive' : 'header'
              "
              tabindex="0"
              (mouseleave)="hideOverlayPanel(opCasco)"
              (click)="selectTypeOfPolicy('casco')"
              (keyup.enter)="selectTypeOfPolicy('casco')">
              <p>{{ t('tab.header2.short') }}</p>
              <div
                class="imgWrapper"
                #imgWrapperCasco>
                <img
                  src="assets/icons/info.svg"
                  class="p-mx-2"
                  alt="info"
                  tabindex="0"
                  (mouseover)="opCasco.show($event)"
                  (focus)="opCasco.show($event)" width="19" height="23">
                <p-overlayPanel
                  class="centralPanel index-2"
                  #opCasco
                  [dismissable]="true"
                  [showTransitionOptions]="'200ms'"
                  [appendTo]="
                    isMobile && calculatorRef ? calculatorRef : imgWrapperCasco
                  "
                  [baseZIndex]="50000">
                  <ng-template pTemplate>
                    <div (mouseleave)="opCasco.hide()">
                      <div class="p-mb-2">
                        <div class="textGrey">
                          <span class="p-text-bold">{{
                            t('tab.header2.long')
                          }}</span>
                          <span [innerHTML]="t('tab.header2.content')"></span>
                        </div>
                      </div>
                      <a routerLink="/gap-casco">{{ t('tab.showMore') }}</a>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </div>
            <div
              class="p-col-4 header"
              [ngClass]="
                typeOfPolicy === 'direct' ? 'header--isActive' : 'header'
              "
              tabindex="0"
              (mouseleave)="hideOverlayPanel(opDirect)"
              (click)="selectTypeOfPolicy('direct')"
              (keyup.enter)="selectTypeOfPolicy('direct')">
              <p>{{ t('tab.header3.short') }}</p>
              <div
                class="imgWrapper"
                #imgWrapperDirect>
                <img
                  src="assets/icons/info.svg"
                  class="p-mx-2"
                  alt="info"
                  tabindex="0"
                  (mouseover)="opDirect.show($event)"
                  (focus)="opDirect.show($event)" width="19" height="23">
                <p-overlayPanel
                  class="rightSidePanel index-3"
                  #opDirect
                  [dismissable]="true"
                  [showTransitionOptions]="'200ms'"
                  [appendTo]="
                    isMobile && calculatorRef ? calculatorRef : imgWrapperDirect
                  "
                  [baseZIndex]="50000">
                  <ng-template pTemplate>
                    <div (mouseleave)="opDirect.hide()">
                      <div class="p-mb-2">
                        <div class="textGrey">
                          <span class="p-text-bold">{{
                            t('tab.header3.long')
                          }}</span>
                          <span [innerHTML]="t('tab.header3.content')"></span>
                        </div>
                      </div>
                      <a routerLink="/gap-flex">{{ t('tab.showMore') }}</a>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </div>
          </div>
          <div class="calculator__content">
            <div class="texts p-text-center">
              <p class="texts__header">{{ t('tab.content.header') }}</p>
              <h1 class="p mb-4">{{ t('tab.content.text1') }}</h1>
              <p [innerHTML]="t('tab.content.text2')"></p>
            </div>

            <form
              [formGroup]="gapCalculatorFormGroup"
              (ngSubmit)="onSubmit()">
              <div class="form-group">
                <div
                  class="inputs inputs__upper p-d-md-flex"
                  [ngStyle]="{
                    'align-items':
                      typeOfPolicy === 'direct' ? 'flex-end' : 'unset',
                  }">
                  <div
                    class="p-field p-mb-0"
                    *ngIf="
                      typeOfPolicy === 'invoice' || typeOfPolicy === 'casco'
                    ">
                    <label for="vehiclePurchasePrice">{{
                      t('tab.content.form.price')
                    }}</label>

                    <app-currency-input
                      dataCy="vehiclePurchasePrice"
                      id="vehiclePurchasePrice"
                      [placeholder]="t('benefits.slider.example.right.2')"
                      controlName="vehiclePurchasePrice"
                      (onBlur)="onVehiclePriceBlur()">
                    </app-currency-input>
                    <app-validation-message
                      [control]="
                        gapCalculatorFormGroup.get('vehiclePurchasePrice')
                      "></app-validation-message>

                    <small
                      id="vehiclePurchasePrice-help"
                      *ngIf="
                        !this.gapCalculatorFormGroup.controls
                          .vehiclePurchasePrice.invalid ||
                        !this.gapCalculatorFormGroup.controls
                          .vehiclePurchasePrice.dirty
                      ">
                      <ng-container *ngIf="typeOfPolicy === 'invoice'">
                        {{ t('tab.content.form.priceDesc') }}
                      </ng-container>
                      <ng-container *ngIf="typeOfPolicy === 'casco'">
                        {{ t('tab.content.form.priceDescCasco') }}
                      </ng-container>
                    </small>
                  </div>
                  <div
                    class="p-field"
                    *ngIf="typeOfPolicy === 'direct'">
                    <label for="claimLimit">{{
                      t('tab.content.form.claimLimit')
                    }}</label>
                    <p-dropdown
                      [options]="claimLimits"
                      class="dropdown"
                      id="claimLimit"
                      formControlName="claimLimit"
                      (onChange)="handleLimitSelection($event)"
                      optionLabel="name"
                      placeholder="20 000 zł"
                      dropdownIcon="pi pi-sort-down"></p-dropdown>
                  </div>
                  <div
                    class="p-field"
                    *ngIf="typeOfPolicy !== 'direct'">
                    <label for="vehicleRegDate">{{
                      t('tab.content.form.year')
                    }}</label>
                    <p-dropdown
                      [options]="years"
                      class="dropdown"
                      data-cy="vehicleRegDate"
                      id="vehicleRegDate"
                      formControlName="vehicleRegDate"
                      (onChange)="handleYearSelection($event)"
                      optionLabel="year"
                      [placeholder]="setActualYearPlaceholder()"
                      dropdownIcon="pi pi-sort-down"></p-dropdown>
                  </div>
                  <div
                    class="p-field"
                    *ngIf="typeOfPolicy === 'direct'">
                    <label for="vehicleRegDateDirect">{{
                      t('tab.content.form.year')
                    }}</label>
                    <p-dropdown
                      [options]="yearsDirect"
                      class="dropdown"
                      id="vehicleRegDateDirect"
                      formControlName="vehicleRegDate"
                      (onChange)="handleYearSelection($event)"
                      optionLabel="year"
                      [placeholder]="setActualYearPlaceholder()"
                      dropdownIcon="pi pi-sort-down"></p-dropdown>
                  </div>
                </div>

                <div
                  class="p-grid p-nogutter p-dir-col inputs inputs__lower"
                  *ngIf="insTermOptions">
                  <p class="label">{{ t('tab.content.form.period') }}</p>
                  <div
                    class="radiobuttonRow"
                    *ngIf="typeOfPolicy !== 'direct'">
                    <ng-container
                      *ngFor="let insTerm of insTermOptions; index as i">
                      <input
                        [id]="'instTerm' + i"
                        type="radio"
                        formControlName="insTerm"
                        [value]="insTerm" />
                      <label [for]="'instTerm' + i">{{ insTerm }}</label>
                    </ng-container>
                  </div>
                  <div
                    class="radiobuttonRow"
                    *ngIf="typeOfPolicy === 'direct'">
                    <ng-container
                      *ngFor="let insTerm of insTermOptionsDirect; index as i">
                      <input
                        [id]="'instTerm' + i"
                        type="radio"
                        formControlName="insTerm"
                        [value]="insTerm" />
                      <label [for]="'instTerm' + i">{{ insTerm }}</label>
                    </ng-container>
                  </div>
                </div>

                <div class="p-d-flex calculate">
                  <div
                    class="p-d-md-flex calculate__buttons"
                    [ngClass]="
                      calculatedPremium || loadingCalculation
                        ? 'p-jc-between'
                        : 'p-jc-center'
                    ">
                    <button
                      type="submit"
                      data-cy="submit"
                      class="buttonWhite p-m-1 p-m-md-0"
                      [class.buttonWhite--inactive]="calculateInactive">
                      {{ t('tab.content.form.calculate') }}
                    </button>

                    <div
                      *ngIf="loadingCalculation"
                      class="spinnerWrapper"
                      aria-live="polite"
                      aria-busy="true">
                      <p-progressSpinner
                        [style]="{ width: '40px', height: '40px' }"
                        styleClass="custom-spinner"
                        strokeWidth="8"
                        fill="#EEEEEE"
                        animationDuration=".5s">
                      </p-progressSpinner>
                    </div>

                    <ng-container *ngIf="!loadingCalculation && calculatedPremium">
                      <div class="dataButton p-m-1 p-m-md-0">
                        <p>
                          {{ calculatedPremium | currency: '' : '' : '1.0-0' }}
                          zł
                        </p>
                        <a
                          class="buttonYellow"
                          data-cy="home-choose-gap"
                          [href]="formUrl('/new-policy/1')"
                          (click)="startPolicyFlow($event)">
                          <app-lock-open-icon
                            class="p-d-none p-d-xl-inline-block"></app-lock-open-icon>
                          {{ t('tab.content.form.buy-gap') }}
                        </a>
                      </div>
                    </ng-container>

                    <p
                      *ngIf="!loadingCalculation && calculationError"
                      class="p-text-center calculate__error"
                      role="alert">
                      Nie udało się obliczyć składki. Spróbuj ponownie.
                    </p>
                  </div>
                  <div
                    *ngIf="calculatedPremium && typeOfPolicy !== 'direct'"
                    class="calculate__description">
                    <p
                      class="p-text-center"
                      [innerHTML]="t('tab.content.form.calculationDesc')"></p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        *ngIf="gapSliderFormGroup"
        class="p-col-12 p-md-6 home__right"
        [formGroup]="gapSliderFormGroup">
        <img
          class="bgImg p-d-none p-d-xl-block"
          src="assets/images/bg2-img.png"
          alt="tear" width="749" height="834">
        <div class="p-grid p-nogutter home__right__header">
          <div class="p-col-12 p-p-0 p-mb-xl-2">
            <h2 class="home-heading">{{ t('policies.header') }}</h2>

            <p
              class="description"
              [innerHTML]="t('policies.question')"></p>
          </div>

          <div class="p-col-12 dataButtonWrapper">
            <p class="textGrey p-d-md-none p-mb-0">
              {{ t('policies.label') }}
            </p>
            <p class="p-d-none p-d-md-block p-mb-0">
              {{ t('policies.label') }}
            </p>
            <div class="dataButton p-my-2">
              <app-currency-input
                [placeholder]="t('benefits.slider.example.right.2')"
                controlName="vehiclePurchasePrice"
                (onBlur)="onVehiclePriceBlur()">
              </app-currency-input>
              <app-validation-message
                [control]="
                  gapSliderFormGroup.get('vehiclePurchasePrice')
                "></app-validation-message>
            </div>
          </div>
        </div>

        <div class="carChart">
          <div class="carChart__sliderWrapper">
            <img
              src="assets/images/car_img.jpg"
              alt="Wykres utraty wartości pojazdu"
              width="752"
              height="483"
              fetchpriority="high" />
            <div class="monthOfUse">
              <p>
                {{ t('policies.monthOfUse')
                }}{{ this.gapSliderFormGroup.controls.monthOfUse.value }}
              </p>
            </div>
            <div class="totalLoss">
              <p>{{ t('policies.totalLose') }}</p>
            </div>
            <!--          <p-slider formControlName="monthOfUse" [min]="0" [max]="60" (onChange)="handleSliding()"></p-slider>-->
            <p-slider
              formControlName="monthsArray"
              [range]="true"
              [min]="0"
              [max]="59"
              (onChange)="handleSliding()"></p-slider>
          </div>
          <div class="p-grid p-nogutter carChart__description">
            <div class="p-col-12 p-md-6 carChart__description__left">
              <p
                class="textSmall"
                [innerHTML]="t('policies.ocAcCompensation')"></p>
              <h3
                class="textBlue p-text-bold"
                *ngIf="
                  simulationAmount(
                    gapSliderFormGroup.controls.policyValue.value
                  ) as insurerPayout
                ">
                {{ insurerPayout | number: '1.0-0' }}
                zł
              </h3>
            </div>
            <div class="p-col-12 p-md-6 carChart__description__right">
              <p
                class="textSmall"
                [innerHTML]="t('policies.gapCompensation')"></p>
              <h3
                class="textYellow p-text-bold"
                *ngIf="
                  simulationAmount(
                    gapSliderFormGroup.controls.gapValue.value
                  ) as gapPayoutAmount
                ">
                {{ gapPayoutAmount | number: '1.0-0' }}
                zł
              </h3>
            </div>
            <div class="p-col-12">
              <p class="textBlue p-text-bold">{{ t('policies.dontWait') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <div class="scrollContainer">
        <div
          class="scrollContainer__link"
          id="whatIsGap"
          style="top: -50px"></div>
      </div>
      <app-what-is-gap class="w100"></app-what-is-gap>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <div class="scrollContainer">
        <div
          class="scrollContainer__link"
          id="benefits"
          style="top: -85px"></div>
      </div>
      <app-benefits></app-benefits>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <app-benefits-slider></app-benefits-slider>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <app-not-a-gap></app-not-a-gap>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <div class="scrollContainer">
        <div
          class="scrollContainer__link forWho"
          id="forWho"></div>
      </div>
      <app-for-who></app-for-who>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <app-valid-vehicles></app-valid-vehicles>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <app-when-to-buy></app-when-to-buy>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <app-documents></app-documents>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <div class="scrollContainer">
        <div
          class="scrollContainer__link faq"
          id="faq"></div>
      </div>
      <app-faq class="w100"></app-faq>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <div class="scrollContainer">
        <div
          class="scrollContainer__link"
          id="contact"
          style="top: -60px"></div>
      </div>
      <app-contact class="w100"></app-contact>
    </div>
    <div class="p-grid p-nogutter p-jc-center">
      <app-cooperation class="w100"></app-cooperation>
    </div>
  </div>
</ng-container>
